module.exports = "https://trybtryb-legacy.web.app/img/build.2c6d44d2.svg";